import {
  GridActionsCellItem,
  GridColumns,
  GridRenderCellParams,
  GridRowParams
} from '@mui/x-data-grid-premium';
import DataGridCell from 'components/common/DataGridCell';
import { useTranslation } from 'react-i18next';
import BackspaceIcon from '@mui/icons-material/Backspace';
import { Tooltip } from '@mui/material';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';

export function WorkstationLinkColumns(handleDelete): GridColumns {
  const translationPrefix = 'entities.workstation_link';
  const { t } = useTranslation();

  const columns: GridColumns = [
    {
      field: 'destination_code',
      headerName: t(`${translationPrefix}.workstation_destination`),
      flex: 1,
      filterable: false,
      renderCell: (params: GridRenderCellParams<string>) => <DataGridCell content={params.value} />
    },
    {
      field: 'weight',
      headerName: t(`${translationPrefix}.weight`),
      width: 300,
      type: 'number',
      editable: true,
      renderCell: (params: GridRenderCellParams<string>) => <DataGridCell content={params.value} />
    },
    {
      field: 'actions',
      type: 'actions',
      width: 150,
      getActions: (params: GridRowParams) => [
        <IsTenantAdministrator key={1}>
          <GridActionsCellItem
            icon={
              <Tooltip title={t('actions.delete')} placement="top">
                <BackspaceIcon />
              </Tooltip>
            }
            onClick={() => handleDelete(params.row)}
            label="remove"
          />
        </IsTenantAdministrator>
      ]
    }
  ];
  return columns;
}
